export default __webpack_public_path__ + "static/media/hot-onion.11c08e8d.png";